import { takeLatest, call, put } from 'redux-saga/effects'
import { fetchRequest, fetchSuccess, fetchFailure } from './slice'
import requestHandler from '../../../utils/requestHandler'

function* fetchConfig() {
  try {
    const url = `${process.env.REACT_APP_SERVER_API || '/'}config`
    const data = yield call(requestHandler, url, { method: 'GET' })
    yield put(fetchSuccess(data))
  } catch (err) {
    yield put(fetchFailure(err?.message || 'failed to load hospital config'))
  }
}

export default function* hospitalConfigSaga() {
  yield takeLatest(fetchRequest.type, fetchConfig)
}
